<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS SGF"
        subTitulo="UABS"
        @click.native="$router.push({ name: 'Uabs_Finalizacoes' })"
        :qtd="qtd"
        :mostrarQtd="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
